/**
 * Maps a `variant` prop onto the shared button classes so this component and
 * the raw `.btn-*` classes used elsewhere stay visually identical.
 */
const VARIANTS = {
  primary: 'btn-primary',
  secondary: 'btn-outline',
  outline: 'btn-outline',
  accent: 'btn-accent',
  danger: 'btn-danger',
  ghost: 'btn-ghost',
};

export default function Button({ variant = 'primary', className = '', children, type = 'button', ...props }) {
  return (
    <button type={type} className={`${VARIANTS[variant] || VARIANTS.primary} ${className}`} {...props}>
      {children}
    </button>
  );
}
